// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Text from "components/typography/Text";
import Block from "components/layout/Block";
import Login from "components/user/Login";
import Spacer from "components/layout/Spacer";

// #####################################################

const MentionDataItem = ({ mention, isPhone }) => {
	const { t } = useTranslation(["common"]);

	// #####################################################

	if (mention.type === "user") {
		return (
			<Block ml={2} flex column>
				<Login
					login={mention.login}
					vip={mention.status_vip}
					maxWidthWithEllipsis={isPhone && 170}
				/>
				<Spacer />
				<Text color="grey" size="0.8rem">
					{t(`common:sexOptions.${mention.sex}`)}
					{mention.sex === "couple"
						? mention?.partner_1?.age && mention?.partner_2?.age
							? " (" +
							  t(
									`common:sexOptions.${mention?.partner_1?.sex}`
							  ) +
							  ` ${mention?.partner_1?.age} ${t(
									"common:years"
							  )}` +
							  ", " +
							  t(
									`common:sexOptions.${mention?.partner_2?.sex}`
							  ) +
							  ` ${mention?.partner_2?.age} ${t(
									"common:years"
							  )}` +
							  ")"
							: " (" +
							  t(
									`common:sexOptions.${mention?.partner_1?.sex}`
							  ) +
							  ", " +
							  t(
									`common:sexOptions.${mention?.partner_2?.sex}`
							  ) +
							  ")"
						: mention?.user_data?.age
						? ` ${mention?.user_data?.age} ${t("common:years")}`
						: ""}
				</Text>
			</Block>
		);
	} else {
		return (
			<Block m={2} py={3} flex column>
				<Text color="black">{t(`common:errors.noResults`)}</Text>
			</Block>
		);
	}
};

// #####################################################

export default MentionDataItem;

// #####################################################
